import _ from 'lodash';
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import reducerStore from '../../reducers/reducerStore';
import Slide from '../Slide/Slide';

class ChannelList extends Component {

    constructor(props) {
        super(props);
        this.state = { showLicenseInfo: false };
    }

    selectChannel(tvIndex) {
        reducerStore.dispatch({ type: 'CHANGE CHANNEL', tvIndex: parseInt(tvIndex), showChannelsModal: false });
    }

    startChannel(tvIndex) {
        this.selectChannel(tvIndex);
        this.props.startSlideshow(true);
    }

    mapChannelCols(num) {
        if (num  < 4) {
            return num + 1;
        } else if (num < 9) {
            return 3;
        } else if (num < 12) {
            return 4;
        } else {
            return 5;
        }
    }

    toggleNewChannel(enableAddButton) {
        if (enableAddButton) {
            this.props.openNewChannelModal();
        } else {
            this.setState({showLicenseInfo: true});
        }
    }

    render() {
        const { channels, currency, licenses, companyProfile, slidesData, tvIndex, tvNames } = this.props;
        const channelList = _.map(channels, (slides) => {
            const slide = _.first(slides);
            const slideClasses = ['slide', 'each-slide', 'thumbnail-slide', 'chanel-slide'];
            const channelItemClasses = ['channel-item',  tvIndex == slide.tvIndex ? 'active' : null];
            return (<div className={channelItemClasses.join(' ')} key={slide.tvIndex}>
                <div className={slideClasses.join(' ')}>
                    <div className='overlay'>
                        <div className='channel-btn' onClick={ () => this.selectChannel(slide.tvIndex)}>
                            <i className='fa fa-cog' aria-hidden='true'></i>Redigera kanal
                        </div>
                        <div className='channel-btn' onClick={ () => this.startChannel(slide.tvIndex)}>
                            <i className='fa fa-play' aria-hidden='true'></i>Starta kanal
                        </div>
                    </div>
                    {tvIndex == slide.tvIndex && <div className='current-channel-label'>
                        <h5>
                            Current
                        </h5>
                    </div>}
                    <Slide
                        key={slide.id}
                        ref={slide.id}
                        slide={slide}
                        slidesData={slidesData}
                        slideId={slide.id}
                        active={true}
                        isThumbnail={true}
                        isChannelThumbnail={true}
                        companyProfile={companyProfile}
                        currency={currency}
                    />
                </div>
                <div className='channel-info'>
                    <div className='channel-index'><h4>{tvNames[slide.tvIndex] || 'Kanal ' + slide.tvIndex}</h4></div>
                    <div className='channel-slides'><p>{`${slides.length} ${slides.length > 1 ? 'slides' : 'slide'}`}</p></div>
                </div>
            </div>
        )});
        const enableAddButton = _.size(channels) < licenses;
        return (
            <div className='channel-overview slides-overview' style={{gridTemplateColumns: `repeat(${this.mapChannelCols(_.size(channels))}, 1fr)`}}>
                {channelList}
                {this.state.showLicenseInfo ?
                    <div className='channel-item license-info'>
                        <div className='info-container'>
                            <h2>Max antal <br /> kanaler skapade</h2>
                            <p>Vill du ha fler kanaler? <br />Kontakta Upsales Support:</p>
                        </div>
                        <div className='email-container'>
                            <a href='mailto:support@upsales.com'>support@upsales.com</a>
                        </div>
                    </div>
                    :
                    <div 
                    className='channel-item add-channel' 
                    onClick={() => this.toggleNewChannel(enableAddButton)}>
                        <i className='fa fa-plus fa-4x' />
                    </div>
                }
            </div>
        );
    }
}

ChannelList.propTypes = {
    channels: React.PropTypes.object,
    companyProfile: React.PropTypes.object,
    openNewChannelModal: React.PropTypes.func,
    currency: React.PropTypes.string,
    licenses: React.PropTypes.number,
    slides: React.PropTypes.array,
    slidesData: React.PropTypes.object,
    startSlideshow: React.PropTypes.func,
    tvIndex: React.PropTypes.number,
    tvNames: React.PropTypes.array,
};

export default ChannelList;



/** WEBPACK FOOTER **
 ** ./client/components/ChannelList/ChannelList.jsx
 **/